import type { ProtocolAlert } from "@/mocks/protocolResponses";

interface Props {
  alerts: ProtocolAlert[];
}

const alertConfig = {
  critica: {
    bg: "bg-red-50 border-red-300",
    icon: "ri-error-warning-fill",
    iconColor: "text-red-500",
    label: "ALERTA CRÍTICA",
    labelBg: "bg-red-100 text-red-800",
  },
  advertencia: {
    bg: "bg-amber-50 border-amber-300",
    icon: "ri-alert-line",
    iconColor: "text-amber-500",
    label: "ADVERTENCIA",
    labelBg: "bg-amber-100 text-amber-800",
  },
  vacio_documental: {
    bg: "bg-background-100 border-background-400",
    icon: "ri-file-unknow-line",
    iconColor: "text-foreground-500",
    label: "VACÍO DOCUMENTAL",
    labelBg: "bg-background-300 text-foreground-700",
  },
  derivacion: {
    bg: "bg-primary-50 border-primary-300",
    icon: "ri-share-forward-line",
    iconColor: "text-primary-500",
    label: "DERIVACIÓN REQUERIDA",
    labelBg: "bg-primary-100 text-primary-800",
  },
};

export default function ProtocolAlertBox({ alerts }: Props) {
  if (alerts.length === 0) return null;

  const criticalCount = alerts.filter((a) => a.tipo === "critica").length;
  const otherCount = alerts.length - criticalCount;

  return (
    <div>
      <div className="flex items-center gap-2.5 mb-4">
        <div className="w-7 h-7 rounded-lg bg-red-100 flex items-center justify-center">
          <i className="ri-shield-flash-line text-red-600 text-sm" />
        </div>
        <h3 className="text-base font-semibold text-foreground-900">Alertas y Avisos</h3>
        {criticalCount > 0 && (
          <span className="text-xs font-semibold text-red-600 bg-red-50 px-2 py-0.5 rounded-full">
            {criticalCount} crítica{criticalCount > 1 ? "s" : ""}
          </span>
        )}
        {otherCount > 0 && (
          <span className="text-xs font-medium text-foreground-500 bg-background-100 px-2 py-0.5 rounded-full">
            {otherCount} más
          </span>
        )}
      </div>

      <div className="space-y-2.5">
        {alerts.map((alert, idx) => {
          const config = alertConfig[alert.tipo];
          return (
            <div
              key={idx}
              className={`flex items-start gap-3 border rounded-xl p-4 ${config.bg}`}
            >
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${config.labelBg}`}>
                <i className={`${config.icon} ${config.iconColor} text-sm`} />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${config.labelBg}`}>
                    {config.label}
                  </span>
                </div>
                <p className="text-sm text-foreground-800 leading-relaxed">{alert.mensaje}</p>
                {alert.fuente && (
                  <p className="text-xs text-primary-600 mt-1.5 flex items-center gap-1">
                    <i className="ri-link text-xs" />
                    {alert.fuente}
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}